import { Module } from 'vuex'

import { State as RootState } from '@/store/state'

import {
  Forms,
  initState,
  getters,
  mutations,
} from './state'
import { actions } from './actions'

const module: Module<Forms, RootState> = {
  namespaced: true,
  state: initState,
  mutations,
  actions,
  getters,
}

export default module
